import React from "react"
import { AppButtonIcon } from "@components"
import { CircularProgress } from "@mui/material"
import { useCloneReport } from "Pages/ReportsAlerts/Reports/@hooks"


export default function ReportTableCloneAction({ isRunning, idReport }) {

	const { isLoading, setLoading } = useCloneReport(idReport)

	if (isLoading) return <CircularProgress size={17} sx={{ m: 0.2 }}/>

	return !isRunning && <AppButtonIcon
		icon="clone"
		tooltip="Clone & Edit"
		onClick={setLoading}
	/>
}